import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService, ModalService, NotificationService, PatientService, SocketService } from '../../services';
import { environment } from '../../../../environments/environment';
import { distinctUntilChanged } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';
import { NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {Notification} from 'rxjs/Notification';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

const io = require('socket.io-client/dist/socket.io.js');
const webNotification = require('simple-web-notification/web-notification.js');

interface Alert {
  type: string;
  message: string;
  timestamp: Date;

}

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit, OnDestroy {

    private one$: Subscription;
    private two$: Subscription;
    private twoEBS$: Subscription;
    private three$: Subscription;
    private four$: Subscription;
    private five$: Subscription;
    private six$: Subscription;
    private seven$: Subscription;
    private flag = true;

    public alerts: Alert[] = [];
    private audio = new Audio('assets/incomingCall.wav');

    constructor(private userService: UserService,
        private modalService: ModalService,
        private notificationService: NotificationService,
        private patientService: PatientService,
        private socketService: SocketService,
        private ngZone: NgZone,
        private translate: TranslateService,
        private router: Router) {
        
    }

    ngOnInit() {

        this.one$ = this.userService.isAuthenticated
            .pipe(distinctUntilChanged())
            .subscribe(data => {
                if (data) {

                    this.ngZone.runOutsideAngular(() => {

                        this.socketService.init(this.userService.getCurrentUser().user_id.id);

                        this.two$ = this.socketService.onAlert()
                            .subscribe(user => {
                                this.ngZone.run(() => {
                                    this.notificationService.addUserAlarm(user);
                                    this.modalService.openSosAlert(user);
                                    this.createNotification(user);
                                });
                            });


                        this.three$ = this.socketService.onAccept()
                            .subscribe(user => {
                                this.ngZone.run(() => {
                                    this.notificationService.deleteUserAlarm(user);
                                });
                            });

                        this.four$ = this.socketService.onNotification()
                            .subscribe(user => {
                                this.ngZone.run(() => {
                                    this.createNotificationStandard(user);
                                });
                            });

                        this.five$ = this.socketService.guestCall()
                          .subscribe(datum => {
                            console.log('guest-call', datum);
                            this.ngZone.run(() => {
                              this.modalService.openGuestAlert(datum);
                            });
                          });

                        this.six$ = this.socketService.refreshPage()
                          .subscribe(datum => {
                            this.ngZone.run(() => {
                              console.log('refresher');
                              window.location.reload();
                            });
                          });


                      this.seven$ = this.socketService.snackbar().subscribe(datum => {
                        this.audio.loop = false;
                        this.audio.play();
                        
                        // Utwórz alert z unikalnym ID
                        const newAlert: Alert = {
                            type: 'warning', 
                            message: 'Zaraz otrzymasz połączenie z opaski od użytkownika ' + datum.name,
                            timestamp: new Date()
                        };
                        
                        this.alerts.push(newAlert);
                        
                        // Auto-usuń ten konkretny alert po 15 sekundach
                        setTimeout(() => {
                            this.alerts = this.alerts.filter(alert => alert !== newAlert);
                        }, 15000);
                        });


                    });

                } else {
                    this.logoutNotifications();
                }
            });

    }

    //FALL i SOS
    createNotification(user) {
        webNotification.showNotification('ALERT SiDLY', {
            body: user.last_name + ' ' + user.first_name,
            icon: 'assets/images/favicon.png',
            onClick: function onNotificationClicked() {
            },
            autoClose: 600000
        }, function onShow(error, hide) {
            /*
            if (error) {
                //window.alert('Unable to show notification: ' + error.message);
            }
            */
        });
    }



    //Prog tetna
    createNotificationStandard(user) {
        webNotification.showNotification('SiDLY ALERT', {

            body: user.userDataPack.last_name + ' ' + user.userDataPack.first_name + ': ' + this.translate.instant('BACKEND.' + user.message),
            icon: 'assets/images/favicon.png',
            onClick: function onNotificationClicked() {
            },
            vibrate: [200, 100, 200, 100, 200, 100, 200],
            autoClose: 600000
        }, function onShow(error, hide) {
            /*
            if (error) {
                //window.alert('Unable to show notification: ' + error.message);
            }
            */
        });
    }

    isNewNotificationSupported() {
        if (!webNotification || !('Notification' in window)) {
            return false;
        }
        return true;
    }


    logoutNotifications() {
        if (this.two$) {
            this.two$.unsubscribe();
        }
        if (this.three$) {
            this.three$.unsubscribe();
        }
        if (this.four$) {
            this.four$.unsubscribe();
        }
        this.notificationService.clean();

        this.socketService.close();
    }


    turnOffModalAlert(data){
        this.flag = data;
    }

removeAlert(alertToRemove: Alert) {
  // Opcjonalnie z animacją
  const alertElement = document.querySelector(`[data-alert-id="${alertToRemove.timestamp.getTime()}"]`);
  if (alertElement) {
    alertElement.classList.add('removing');
    setTimeout(() => {
      this.alerts = this.alerts.filter(alert => alert !== alertToRemove);
    }, 300);
  } else {
    this.alerts = this.alerts.filter(alert => alert !== alertToRemove);
  }
}

    ngOnDestroy() {
        if (this.one$) {
            this.one$.unsubscribe();
        }
        this.logoutNotifications();
    }

    
}



// WEBPACK FOOTER //
// ./src/app/shared/components/notifications/notifications.component.ts